import React from 'react';
import {Input} from 'formsy-react-components';
import PropTypes from 'prop-types';
import {cleanProps} from 'formsy-react-components/release/prop-utilities';
import Icon from 'formsy-react-components/release/icon';
import Row from 'formsy-react-components/release/row';
import {sanitizeHtml} from '../../common/util/sanitizeHtml';
import SafeHTML from '../fw/SafeHTML.react';

// eslint-disable-next-line
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

interface PlainTextProps {
    htmlHelp?: string;
    renderAsHtml?: boolean;
}

export default class PlainText extends Input<PlainTextProps> {
	static propTypes = {
		htmlHelp: PropTypes.string,
		renderAsHtml: PropTypes.bool,
    };

	renderHelp = function() {
		if (this.props.htmlHelp) {
			return (
				<SafeHTML className="help-block" value={this.props.htmlHelp} />
			);
		}

		if (this.props.help) {
			return (
				<span className="help-block">{this.props.help}</span>
			);
		}

		return null;
	};

    renderElement = function() {
        let self = this;

        let className = '';
		let propsCopy = JSON.parse(JSON.stringify(this.props));
		delete propsCopy.htmlHelp;
		delete propsCopy.renderAsHtml;

		let content;

		if (this.props.renderAsHtml) {
			content = <div><SafeHTML value={this.getValue()} /></div>;
		} else {
			content = sanitizeHtml(this.getValue());
		}

        return React.createElement('div', _extends({
            ref: function ref(c) {
				self.element = c;
                return self.element;
            },
            className: className
        }, cleanProps(propsCopy), {
            id: this.getId(),
        }), <div>{content}<input type="hidden" value={this.getValue()} /></div>);
    };

	render() {
        let element = this.renderElement();

        if (this.props.type === 'hidden') {
            return element;
        }

        if (this.props.addonBefore || this.props.addonAfter || this.props.buttonBefore || this.props.buttonAfter) {
            element = this.renderInputGroup(element);
        }

        if (this.getLayout() === 'elementOnly') {
            return element;
        }

        let warningIcon = null;
        if (this.showErrors()) {
            warningIcon = React.createElement(Icon, { symbol: 'remove', className: 'form-control-feedback' });
        }

        return React.createElement(
            Row,
            _extends({}, this.getRowProperties(), {
                htmlFor: this.getId()
            }),
            element,
            warningIcon,
            this.renderHelp(),
            this.renderErrorMessage()
        );
    }
}
